import { render, staticRenderFns } from "./del-exam-modal.vue?vue&type=template&id=df0f3a4a&scoped=true"
import script from "./del-exam-modal.vue?vue&type=script&lang=ts"
export * from "./del-exam-modal.vue?vue&type=script&lang=ts"
import style0 from "./del-exam-modal.vue?vue&type=style&index=0&id=df0f3a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0f3a4a",
  null
  
)

export default component.exports